import {createSelector} from 'reselect';
import {currentView} from 'src/shared/currentView/selectors';
import {LOADING} from 'src/shared/currentView/commonViews';
import {SMS_ENROLLED, SMS_ENROLLMENT, ERROR_SCREEN} from 'src/pages/reportIssue/constants/views';

export const screenName = createSelector(
  currentView,
  currentView => {
    switch (currentView) {
      case LOADING:
        return 'watchtower';
      case SMS_ENROLLMENT:
        return 'phone number';
      case SMS_ENROLLED:
        return 'confirmation';
      case ERROR_SCREEN:
        return 'error';
      default:
        return 'report issue';
    }
  }
);
